import React from 'react'
import Layout from '../Layout'
import { Box, Container, Typography } from '@material-ui/core'
import { useNavigate } from 'react-router-dom'
import SelectAssetComponent from '../SelectAsset'
import CustomBreadcrumbs from '../Breadcrumb'

const SelectAsset = () => {
    const navigate = useNavigate();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        // { label: 'Reporting', href: '/trigger-breakdown' },
    ];

    const handleAssetSelection = (asset) => {
        console.log("Asset:", asset);
        navigate(`/report-breakdown/add-details/${asset?.Asset_id || asset?.id}`)
        // navigate(`/report-breakdown/add-details/${asset.id}`)
    };

    return (
        <Layout>
            <Container>
                <Box mt={1} mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Select Asset for Reporting Breakdown" />
                </Box>
                <SelectAssetComponent title="Select Asset for reporting Breakdown" handleAssetSelection={handleAssetSelection} />
            </Container>
        </Layout >
    )
}

export default SelectAsset